/*
  <footer-localization> — Concept's footer selector behaviour: each language /
  country pill is a plain localization form with a transparent native <select>
  stretched over it, so the click opens the OS dropdown. Picking an option
  submits the form. Styles live in sections/footer.liquid (.footer-loc).

  Autonomous element (not `is="..."`) because WebKit doesn't support
  customized built-ins.
*/
(function () {
  if (customElements.get('footer-localization')) return;

  customElements.define(
    'footer-localization',
    class FooterLocalization extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.addEventListener('change', function (event) {
          var form = event.target.closest('form');
          if (form) form.submit();
        });
      }
    }
  );
})();
